const ACTION = "GENERAL_ACTION";
const SET_THEME = "SET_THEME";
const SET_PRODUCT_SEARCH = "GENERAL_SET_PRODUCT_SEARCH";

export const setTheme = (theme: any) => {
  return {
    type: SET_THEME,
    payload: theme,
  };
};
export const setProductSearch = (query: any) => {
  return {
    type: SET_PRODUCT_SEARCH,
    payload: query,
  };
};

const initialState = {
  theme: { primaryColor: "", secondaryColor: "", cover: "" },
  productSearch: "",
};

export default (previousState = initialState, { type, payload }: any) => {
  if (type === ACTION) {
    return { ...previousState };
  }
  if (type === SET_THEME) {
    return { ...previousState, theme: { ...previousState.theme, ...payload } };
  }
  if (type === SET_PRODUCT_SEARCH) {
    return { ...previousState, productSearch: payload };
  }
  return previousState;
};
